import { Button, styled } from "@mui/material";
import { CONSTANTS } from "../../CONSTANTS";

const StyledPrimaryButton = styled(Button)({
    background: `${CONSTANTS.COLORS.BUTTON_BLUE} 0% 0% no-repeat padding-box`,
    color: CONSTANTS.COLORS.TEXT_WHITE,
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Arial",
    textTransform: "capitalize",
    lineHeight: "30px",
    borderRadius: "32px",
    opacity: 1,
    minWidth: "122px",
    maxHeight: "32px",
})

const WrappedPrimaryButton = (props: any) => {
    return (
        <StyledPrimaryButton variant="contained" size="medium" {...props}>
            {props.children}
        </StyledPrimaryButton>
    );
};

export default WrappedPrimaryButton as typeof Button;